function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M28.02 8H3.98A3.98 3.98 0 000 11.98v24.04C0 38.22 1.78 40 3.98 40h24.04c2.2 0 3.98-1.78 3.98-3.98V11.98C32 9.78 30.22 8 28.02 8zm15.78 3.14l-9.13 6.3v13.12l9.13 6.29c1.77 1.22 4.2-.03 4.2-2.15V13.3c0-2.12-2.42-3.37-4.2-2.16z"
})));